function Filtros( _vm ) {

    this.vm = _vm;

    this.descricaoGrupo = function ( _pagina ) {

        var grupoFiltrado = '';
        for (var id in this.vm[ _pagina ]) {
            grupoFiltrado = this.vm[ _pagina ][ id ].grupo;
            break;
        }

        switch (grupoFiltrado) {
            case 'concurso':
                return 'de Concursos';
            case 'oab':
                return 'da OAB';
            case 'enem':
                return 'de ENEM';
            case 'vestibular':
                return 'de Vestibulares'
        }

    };


    this.toggleDual = function (alterar, nome) {

        if( !this.vm.logado &&
            ((nome == 'resolvi') || (nome == 'naoresolvi') ||
            (nome == 'acertei') || (nome == 'errei')) )
        {
            return nav.open('register');
        }

        alterar.valor = !alterar.valor;
        this.vm.maisopcoes.opcoes[alterar.dual].valor = false;

        if (alterar.valor && (nome == 'naoresolvi')) {
            this.vm.maisopcoes.opcoes.acertei.valor = false;
            this.vm.maisopcoes.opcoes.errei.valor = false;
        }
        if (alterar.valor && (nome == 'acertei' || nome == 'errei')) {
            this.vm.maisopcoes.opcoes.naoresolvi.valor = false;
        }

    };

    /* @todo Aqui deve mostra apenas os filtros de PROVAS salvos */
    this.meusFiltros = function ( _pagina ) {
        if (!this.vm.logado) {
            return nav.open('register');
        }

        fechaTooltips();
        vmMeusFiltros.abrirModal( _pagina );
    };

    
    this.limparTodos = function () {

        var self = this;
        var msg = {
            titulo: "Tem Certeza?",
            conteudo: "Todos os filtros atualmente selecionados serão limpos."
        };
        confirma(msg, function () { self.limpaTodosFiltros(); }, null);
    };

    
    this.limpaTodosFiltros = function () {

        for(var nomeFiltro in this.vm.filtros){
            if( nomeFiltro != 'grupos' ) {
                this.vm.filtros[nomeFiltro].ativo = false;
                this.vm.filtros[nomeFiltro].selecionados = [];
                if( this.vm.filtros[nomeFiltro].hasOwnProperty('carregando') ) {
                    this.vm.filtros[nomeFiltro].opcoes = [];
                }
            }
        }

        if( this.totalMaisOpcoesAtivas() ){
            for(var mo in this.vm.maisopcoes.opcoes){
                this.vm.maisopcoes.opcoes[mo].valor = false;
            }
        }
        this.vm.maisopcoes.ativo = false;

    };
    

    this.totalFiltrosAtivos = function ( _rota ) {

        var selecionados = [];
        for (var filtro in this.vm.filtros) {
            selecionados[filtro] = this.vm.filtros[filtro].selecionados.length;
        }

        var grupoSelecionado = this.vm.filtros.grupos.selecionados[0];

        var total = selecionados['palavras'] + selecionados['desde'] + selecionados['ate'];

        /* Só na página questões há esses filtros */
        if( _rota == 'questoes' ){
            total += selecionados['disciplinas'] + selecionados['assuntos'] + selecionados['tipos'];
        }

        if (grupoSelecionado == 'concurso') {
            total += selecionados['niveis'] + selecionados['cargos'];
        }

        if (grupoSelecionado != 'enem') {
            total += selecionados['orgaos'] + selecionados['bancas'] + selecionados['areasformacao'];
        }

        if (grupoSelecionado == 'enem') {
            total += selecionados['areasconhecimento'];
        }

        total += this.totalMaisOpcoesAtivas();

        return total;
    };


    this.totalMaisOpcoesAtivas = function () {

        var total = 0;

        for(var op in this.vm.maisopcoes.opcoes){
            total += this.vm.maisopcoes.opcoes[op].valor;
        }

        return total;
    };


    this.confirmaMudancaGrupo = function (oldVal) {

        var self = this;

        confirma(
            {
                titulo: "Você tem certeza?",
                conteudo: "Ao fazer esta mudança alguns filtros já selecionados serão limpos e recarregados."
            },
            {
                cbSim: function(){ self.limparFiltrosAjax() },
                cbNao: function(){ self.cancelaMudancaGrupo(oldVal) }
            },
            {
                dadosSim: null,
                dadosNao: oldVal
            }
        );
    };


    this.limparFiltrosAjax = function () {

        for(var filtro in this.vm.filtros){
            if( this.vm.filtros[filtro].hasOwnProperty('carregando') ) {
                this.vm.filtros[filtro].selecionados = [];
                this.vm.filtros[filtro].opcoes = [];
                this.vm.filtros[filtro].ativo = false;
            }
        }

    };


    this.cancelaMudancaGrupo = function (oldVal) {

        var self = this;
        this.vm.suspendeWatchs = true;
        this.vm.filtros.grupos.selecionados = oldVal;

        Vue.nextTick(function () {
            self.vm.suspendeWatchs = false;
        });
    };


    this.expandirFiltro = function (filtro) {

        if (filtro.carregando) {
            return false;
        }

        var self = this;

        // Abrir outro filtro remove a msg de erro
        if( this.vm.filtros.assuntos != null ){
            this.vm.filtros.assuntos.faltadependencia = false;
        }

        /* Retorna uma mensagem caso queira abrir Assuntos
         * sem ter selecionado Disciplinas */
        if (filtro.nome == 'assuntos') {
            if (!this.vm.filtros.disciplinas.selecionados.length) {
                this.vm.filtros.assuntos.faltadependencia = true;
                return false;
            }
        }

        // carrega o select via AJAX, caso esteja vazio
        // As palavras-chave obviamente não geram requisição AJAX, e aceitam tag
        if (!filtro.ativo && (!filtro.opcoes.length)
            && (filtro.nome != 'palavras') && (filtro.nome != 'maisopcoes')) {

            // Mostra o gif de carregando
            filtro.carregando = true;

            // Adiciona dependência
            var dependencias = null;
            if (filtro.nome == 'assuntos') {
                dependencias = this.vm.filtros.disciplinas.selecionados;
            }

            ajaxGET(
                "/filtros/carrega-filtro",
                {
                    grupo: this.vm.filtros.grupos.selecionados[0],
                    filtro: filtro.nome,
                    dependencias: dependencias
                },
                function(dados){ self.carregaOpcoes(dados) }
            );

        } else {
            // isso dispara a animação do slideDown/slideUp
            filtro.ativo = !filtro.ativo;
        }

    };
    
    
    this.carregaOpcoes = function (dados) {

        var filtro = this.vm.filtros[dados.filtro];

        filtro.opcoes = dados.opcoes;
        filtro.carregando = false; //deve ir pra false ANTES do 'ativo'

        Vue.nextTick(function () {
            $('#select-' + filtro.nome).val(filtro.selecionados).trigger('change'); /* Necessário! */
            filtro.ativo = !filtro.ativo;
        });

    };


    this.filtrar = function ( _irParaPag1 ) {

        /* Dou RETURN porque o watch de 'paginaAtual' vai chamar a função filtrar() novamente */
        if ( _irParaPag1 && (this.vm.paginaAtual != 1)) {
            return this.vm.paginaAtual = 1;
        }

        // var self = this;
        var grupo = this.vm.filtros.grupos.selecionados ? this.vm.filtros.grupos.selecionados : ["enem"];

        var rota = '#/filtrar/' + grupo + '/';

        var selecionados;
        for (var i in this.vm.filtros) {
            if (this.vm.filtros[i].selecionados.length && (this.vm.filtros[i].nome != 'grupos')) {
                selecionados = (this.vm.filtros[i].nome == 'palavras') ?
                    this.trataPalavras( this.vm.filtros.palavras.selecionados ) : this.vm.filtros[i].selecionados;
                rota += '&' + this.vm.filtros[i].nome + '=' + JSON.stringify(selecionados);
            }
        }

        if( this.totalMaisOpcoesAtivas() ){

            rota += '&maisopcoes=1';
            for (var opcaoNome in this.vm.maisopcoes.opcoes) {
                if (this.vm.maisopcoes.opcoes[opcaoNome].valor) {
                    rota += '&' + opcaoNome + '=1';
                }
            }
        }

        /* Se eu tiver filtrando por prova (vindo da url), preciso guardar quais provas são essas
         *  pra quando trocar de página.
         */
        if( this.vm.hasOwnProperty('questoes') ){
            rota += this.vm.questoesDasProvas.length ? ('&provas=' + JSON.stringify(this.vm.questoesDasProvas)) : '';
            rota += this.vm.questoesPorPag ? ('&qpp=' + this.vm.questoesPorPag) : '';
        }

        rota += '&pag=' + this.vm.paginaAtual;

        // Se algo nos hash mudou => dispara filtrarPelaHashUrl()
        location.hash = rota;

        // recolhe painel de filtros
        $('#botao-toggle-painel-filtros').click();
    };


    this.trataPalavras = function ( palavras ) {

        var palavrasTratadas = [];
        for (var i in palavras) {
            palavrasTratadas[i] = palavras[i].replace('&', '').replace('=', '').replace('/', '');
        }

        return palavrasTratadas;
    };


    this.verificaHash = function () {

        var hash = location.hash;

        /* Consulta individual de questão, tipo: /questoes#q=[1,2,3,4] */
        if( this.vm.$data.hasOwnProperty('questoes') && ((hash.substring(0, 2) == '#q') || hash.substring(0, 2) == '#Q')) {
            this.vm.consultaQuestao(hash);
        }

        /* Consulta individual de prova, tipo: /provas#p1234 */
        if( this.vm.$data.hasOwnProperty('provas') && ((hash.substring(0, 2) == '#p') || hash.substring(0, 2) == '#P')) {
            this.vm.consultaProva(hash);
        }

        if (hash.substring(1, 10) == '/filtrar/') {
            if (hash.substring(10, 15) == 'enem/') {
                this.vm.filtros.grupos.selecionados = ["enem"];
                this.filtrarPelaHashUrl(hash.substring(15));
            } else if (hash.substring(10, 14) == 'oab/') {
                this.vm.filtros.grupos.selecionados = ["oab"];
                this.filtrarPelaHashUrl(hash.substring(14));
            } else if (hash.substring(10, 19) == 'concurso/') {
                this.vm.filtros.grupos.selecionados = ["concurso"];
                this.filtrarPelaHashUrl(hash.substring(19));
            } else if (hash.substring(10, 21) == 'vestibular/') {
                this.vm.filtros.grupos.selecionados = ["vestibular"];
                this.filtrarPelaHashUrl(hash.substring(21));
            }
        } else {
            this.vm.suspendeWatchs = false;
        }
    };

    this.filtrarPelaHashUrl = function ( _parametros ) {

        var filtrosPermitidos = ['provas', 'niveis', 'orgaos', 'cargos', 'bancas', 'areasformacao',
            'areasconhecimento', 'desde', 'ate', 'maisopcoes', 'pag'
        ];

        if( this.vm.$data.hasOwnProperty('provas') ){
            this.vm.provas = [];
            this.vm.totalProvas = -1;
            filtrosPermitidos = filtrosPermitidos.concat(['transcritas', 'naotranscritas']);
        }

        if( this.vm.$data.hasOwnProperty('questoes') ){
            this.vm.questoes = [];
            this.vm.totalQuestoes = -1;
            filtrosPermitidos = filtrosPermitidos.concat(['palavras', 'disciplinas', 'assuntos', 'tipos', 'resolvi',
                'naoresolvi', 'acertei', 'errei', 'comresolucao', 'semresolucao', 'anuladas', 'desatualizadas', 'qpp']);
        }

        var dadosParaAjax = {};
        scrollToTop(500);
        dadosParaAjax['grupos'] = this.vm.filtros.grupos.selecionados;

        if ( _parametros ) {
            var filtros = _parametros.split('&');

            /* Transforma 'orgaos=["1","2","3"]' em dadosParaAjax = { orgaos: ["1","2","3"] }*/
            for (var i in filtros) {
                var filtro = filtros[i].split('=');
                if (filtrosPermitidos.indexOf(filtro[0]) >= 0) {
                    dadosParaAjax[filtro[0]] = JSON.parse(decodeURIComponent(filtro[1]));
                }
            }
        }

        this.sincronizaModelComUrl(dadosParaAjax);

        if( this.vm.$data.hasOwnProperty('questoes') ){
            return this.vm.carregaQuestoes(dadosParaAjax);
        }

        if( this.vm.$data.hasOwnProperty('provas') ){
            return this.vm.carregaProvas(dadosParaAjax);
        }

    };


    this.sincronizaModelComUrl = function (dadosDaUrl) {

        // $('#select-palavras').val('').trigger('change');
        this.vm.suspendeWatchs = true;

        var especiais = ['provas', 'pag', 'maisopcoes'];

        if( this.vm.$data.hasOwnProperty('questoes') ){
            especiais = especiais.concat(['qpp', 'resolvi', 'naoresolvi', 'acertei', 'errei',
                'comresolucao', 'semresolucao', 'anuladas', 'desatualizadas']);
            this.vm.questoesPorPag = dadosDaUrl.hasOwnProperty('qpp') ? dadosDaUrl.qpp : 10;
            this.vm.questoesDasProvas = dadosDaUrl.hasOwnProperty('provas') ? dadosDaUrl.provas : [];
        }

        if( this.vm.$data.hasOwnProperty('provas') ){
            especiais = especiais.concat(['transcritas', 'naotranscritas']);
        }

        for (var filtroNome in dadosDaUrl) {
            if (especiais.indexOf(filtroNome) < 0) {
                if (filtroNome == 'palavras' && !this.vm.filtros.palavras.selecionados.length) {
                    this.vm.filtros.palavras.opcoes = dadosDaUrl[filtroNome];
                }
                this.vm.filtros[filtroNome].selecionados = dadosDaUrl[filtroNome];
            }
        }

        /* Guarda os estados das chaves "Mais Opções" */
        if (dadosDaUrl.hasOwnProperty('maisopcoes')) {
            for (var key in this.vm.maisopcoes.opcoes) {
                this.vm.maisopcoes.opcoes[key].valor = dadosDaUrl.hasOwnProperty(key);
            }
        }

        this.vm.paginaAtual = dadosDaUrl.hasOwnProperty('pag') ? dadosDaUrl.pag : 1;
        this.vm.inputPagina = this.vm.paginaAtual;

    };
}